<template>
  <div class="new-button-box" :class="`${type}-box-btn`">
    <el-button
      @click.prevent="$emit('click', $event)"
      :size="size"
      :style="styleTextObj"
      :disabled="disabled"
      :loading="loading">
      <slot v-if="$slots.default"></slot>
      <span v-else>{{ label }}</span>
    </el-button>
  </div>
</template>
<script>
export default {
  props: {
    // default 默认
    // blue 主题色
    // break 主题色
    // lightBlue 主题色-带背景
    // blueLine 主题色-带边框
    // text 黑色-文本
    // blueText 主题色-文本(禁用时颜色为灰色)
    // blueDisabled 主题色-禁用文本(禁用时颜色为半透明主题色)
    // defaultLine

    // 兼容旧版本云起BI
    label: {
      type: String,
      default: "",
    },

    type: {
      type: String,
      default: "default",
    },
    // 传递给按钮的行内样式
    styleTextObj: {
      type: Object,
      default: null,
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false,
    },
    // size
    size: {
      type: String,
      default: "small",
    },
  },
};
</script>
<style lang="scss" scoped>
.new-button-box {
  display: inline-block;
  button {
    border-radius: 4px !important;
    font-weight: 400;
    font-size: $main-size !important;
  
  }
  :deep(.el-button--small) {
    height: 32px;
    padding: 0 14px;
  }
  & + & {
    margin-left: 8px;
  }
}
.blue-box-btn {
  button {
    color: #ffffff;
    background-color: $theme-color;
    border-color: $theme-color;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: #ffffff;
    background-color: $theme-color;
    border-color: $theme-color;
    opacity: 0.5 !important;
  }
}
// .break-box-btn {
//   button {
//     color: #ffffff;
//     background-color: $theme-color;
//     border-color: $theme-color;
//   }
//   button:hover {
//     opacity: 0.8;
//   }
//   .is-disabled {
//     opacity: 0.5 !important;
//   }
//   .is-disabled:hover {
//     color: #ffffff;
//     background-color: $theme-color;
//     border-color: $theme-color;
//     opacity: 0.5 !important;
//   }
// }
.lightBlue-box-btn {
  button {
    color: $theme-color;
    background-color: rgba(39, 104, 255, 0.1);
    border: 1px solid rgba(39, 104, 255, 0) !important;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $theme-color;
    background-color: rgba(39, 104, 255, 0.1);
    border: 1px solid rgba(39, 104, 255, 0) !important;
    opacity: 0.5 !important;
  }
}

.blueLine-box-btn {
  button {
    color: $theme-color;
    background-color: #ffffff;
    border: 1px solid $theme-color !important;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $theme-color;
    background-color: #ffffff;
    border: 1px solid $theme-color !important;
    opacity: 0.5 !important;
  }
}
.defaultLine-box-btn {
  button {
    color: $text-color;
    background-color: #ffffff;
    border: 1px solid $border-brc !important;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $text-color;
    background-color: #ffffff;
    border: 1px solid $border-brc !important;
    opacity: 0.5 !important;
  }
}

.blueLine-box-btn {
  button {
    color: $theme-color;
    background-color: #ffffff;
    border: 1px solid $theme-color !important;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $theme-color;
    background-color: #ffffff;
    border: 1px solid $theme-color !important;
    opacity: 0.5 !important;
  }
}

.default-box-btn {
  button {
    color: $text-color !important;
    background-color: #ffffff;
    border: 1px solid #DCDEE1 !important;
    border-color: #DCDEE1 !important;
    font-size: $main-size;
  }
  button:hover {
    color: #333333;
    background-color: rgba(0, 0, 0, 0.04);
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: #666666;
    background-color: #f2f3f5;
    border: 1px solid #f2f3f5 !important;
    opacity: 0.5 !important;
  }
}

.blueText-box-btn {
  button {
    color: $theme-color;
    background-color: transparent;
    border: 1px solid transparent !important;
    padding: 0 !important;
    height: auto !important;
    font-size: $main-size;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    color: #bfbfbf;
  }
  .is-disabled:hover {
    color: #bfbfbf;
    background-color: transparent;
    border: 1px solid transparent !important;
  }
  & + & {
    margin-left: 12px !important;
  }
}

.blueDisabled-box-btn {
  button {
    color: $theme-color;
    background-color: transparent;
    border: 1px solid transparent !important;
    padding: 0 !important;
    height: auto !important;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $theme-color;
    background-color: transparent;
    border: 1px solid transparent !important;
    opacity: 0.5 !important;
  }
  & + & {
    margin-left: 12px;
  }
}

.text-box-btn {
  button {
    color: #333333;
    background-color: transparent;
    border: 1px solid transparent !important;
    padding: 0 !important;
    height: auto !important;
    font-size: $main-size;
  }
  button:hover {
    color: #666666;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: #666666;
    background-color: transparent;
    border: 1px solid transparent !important;
    opacity: 0.5 !important;
  }
  & + & {
    margin-left: 12px !important;
  }
}

.greyBg-box-btn {
  button {
    color: $text-color !important;
    background: #F5F5F7;
    border: 1px solid #EFEFEF;
  }
  button:hover {
    opacity: 0.8;
  }
  .is-disabled {
    opacity: 0.5 !important;
  }
  .is-disabled:hover {
    color: $theme-color;
    background-color: #ffffff;
    border: 1px solid $theme-color !important;
    opacity: 0.5 !important;
  }
}
</style>
